// Mirrors ORDER_TYPES in constants.ts; kept import-free so the .check.ts runs under plain node.
export type OrderType = 'DINE_IN' | 'TAKEAWAY' | 'DRIVE_THRU';

const TAG_RE = /^\[(DINE_IN|TAKEAWAY|DRIVE_THRU)\]\s*/;

/** The backend has no order-type field: it rides as a leading "[TAG] " on notes (same as Android `OrderType.fromNotes`). */
export const tagNotes = (orderType: OrderType, notes = ''): string =>
    notes.trim() ? `[${orderType}] ${notes.trim()}` : `[${orderType}]`;

/** Split a tagged note back into its order type (null when untagged) and the human note. */
export const parseOrderType = (notes: string | null | undefined): { orderType: OrderType | null; notes: string } => {
    const raw = notes ?? '';
    const m = TAG_RE.exec(raw);
    return m ? { orderType: m[1] as OrderType, notes: raw.slice(m[0].length) } : { orderType: null, notes: raw };
};
